import React, { useRef, useEffect, useState } from "react";
import { Button, Col, Row, Form } from "@themesberg/react-bootstrap";
import {
  paymentMethods, statusType, tableHeaders,
  transactionTableHeaders,
} from "../constants";
import useTransactionBList from "../hooks/useTransactionBList";
import DateRangePicker from "../../../../components/DateRangePicker";
import TransactionsList from "../../../../components/TransactionsList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRedoAlt, faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { CustomCol, StyledSelect } from "../style";
import NotificationIconContainer from "../../../../components/NotificationIcon/NotificationIconContainer";

import useTableCustom from "../../../../components/CusotmFilter"
import DateFilterDropdown from "../../../../components/CustomDateFilterOptions";

// import ConfirmationModal from '../ConfirmationModal'




export default function Deposits() {
  const {
    setLimit,
    setPage,
    totalPages,
    limit,
    page,
    state,
    setState,
    transactions,
    loading,
    status,
    setStatus,
    setSearchString,
    setPaymentMethod,
    paymentMethod,
    searchString,
    openStatusModal,
    closeStatusModal,
    handleStatusChange,
    updateTransactionStatus,
    updatingStatus,
    newStatus,
    showStatusModal,
    selectedTransaction,
    driversList,
    agentId,
    handleAgentIdChange,
    handleDownload,
    setSelectedFilter,
    selectedFilter,
    onResetDateFiltered,
    openCryptoStatusModal,
    showCryptoStatusModal,
    setShowCryptoStatusModal,
    updateCryptoTransactionStatus,
    loadingCrypto,
    setSelectedTransaction,
    selectedCrypto,
    totalCount


  } = useTransactionBList({ isUserDetail: false, transactionType: 'deposit' });

  const headerRef = useRef(null);
  const filterRef = useRef(null);

  const [tableMaxHeight, setTableMaxHeight] = useState();

  const {
    visibleColumns,
    pageData,
    customColSetting,
    noDataFound,

  } = useTableCustom(transactions?.rows,
    transactionTableHeaders?.deposit,
    false,
    () => { },
    null,
    null,
    false,
    "",
    true,
    "deposit");

  useEffect(() => {
    const updateMaxHeight = () => {

      const headerHeight = headerRef.current?.offsetHeight || 0;
      const filterHeight = filterRef.current?.offsetHeight || 0;
      const responsiveTable = document.querySelector('.table-responsive');
      const totalHeight = headerHeight + filterHeight; // Add any margin/padding if needed
      const availableHeight = window.innerHeight - totalHeight - 125;
      if (responsiveTable) {
        if (window.innerWidth < 1000) {
          // For smaller screens: reset to full height
          if (responsiveTable) {
            responsiveTable.style.maxHeight = '100%';
            responsiveTable.style.overflowY = 'unset';
          }
          setTableMaxHeight('100%');
          return;
        }
        else {
          responsiveTable.style.maxHeight = `${availableHeight}px`;
          responsiveTable.style.overflowY = 'auto'; // ensure scrolling
        }

        setTableMaxHeight(`${availableHeight}px`);
      }

    };

    updateMaxHeight(); // initial run
    window.addEventListener("resize", updateMaxHeight);
    return () => window.removeEventListener("resize", updateMaxHeight);
  }, [transactions, visibleColumns]);

  return (
    <div>
      <div className="section-header-wrap mt-0 mx-n3" ref={headerRef}>
        <Row className="align-items-center">
          <Col lg={6} xs={6}>
            <h2 className="title-text">Deposit Requests</h2>
          </Col>
          <Col lg={6} xs={6} className="text-end">
            <NotificationIconContainer />
          </Col>
        </Row>
      </div>

      <div className="FormsBg" ref={filterRef}>
        <Row className="g-2 align-items-center" style={{ rowGap: "0.25rem" }}>
          <CustomCol xs={12} md={4} lg={4}>
            <Form.Control
              type="search"
              value={searchString}
              placeholder="Search by name or email"
              onChange={(e) => setSearchString(e.target.value)}
              className="mb-2 mb-md-0"
            />
          </CustomCol>

          <CustomCol xs={12} md={6} lg={3}>
            <StyledSelect
              size="sm"
              value={paymentMethod}
              onChange={(e) => setPaymentMethod(e.target.value)}
              className="mb-2 mb-md-0"
            >
              <option value=''>Filter by payment method</option>
              {paymentMethods.slice(0, 5).map(({ label, value }) => (
                <option key={label} value={value}>{label}</option>
              ))}
            </StyledSelect>
          </CustomCol>

          <CustomCol xs={12} md={3} lg={2}>
            <StyledSelect
              size="sm"
              value={status}
              onChange={(e) =>
                setStatus(e.target.value.replace(/[~`!$%^&*#=)()><?]+/g, ""))
              }
              className="mb-2 mb-md-0"
            >
              {statusType.map(({ label, value }) => (
                <option key={label} value={value}>{label}</option>
              ))}
            </StyledSelect>
          </CustomCol>




          <CustomCol xs={12} md={3} lg={2}>
            <DateFilterDropdown state={state}
              setState={setState} selectedFilter={selectedFilter} setSelectedFilter={setSelectedFilter} />
          </CustomCol>



          {selectedFilter === "custom" && <CustomCol xs={12} md={3} lg={2}>
            <DateRangePicker state={state} setState={setState} size="sm" className="mb-2 mb-md-0" isMAXwidth={true} />
          </CustomCol>}



          <Row className="g-2 align-items-center mt-2 mt-md-0">
            <Col xs={12}>
              <div className="d-flex flex-column flex-sm-row justify-content-between gap-2 w-100">
                <div>


                  {/* Left: Reset Button */}
                  <Button
                    className="d-flex align-items-center btn-primary gap-3  w-auto"
                    style={{ height: '2.2rem', minWidth: 'max-content' }}
                    size="sm"
                    onClick={() => {
                      setSearchString("");
                      setPaymentMethod("");
                      setLimit(15);
                      setPage(1);
                      setStatus("");
                      onResetDateFiltered()
                      // setState([{ startDate: null, endDate: null, key: "selection" }]);
                    }}
                  >
                    <span>Reset Filters</span>
                    <FontAwesomeIcon icon={faRedoAlt} />
                  </Button>
                </div>
                {/* Right: Download + Columns */}
                <div className="d-flex flex-column flex-sm-row gap-2 align-items-start align-items-sm-center ms-md-auto">

                  <div>
                    {customColSetting}
                  </div>

                  <Button
                    className="d-flex align-items-center btn-primary gap-2"
                    style={{ height: '2.2rem', minWidth: 'max-content' }}
                    size="sm"
                    disabled={transactions?.count === 0}
                    onClick={() => handleDownload('csv', 'Deposit Requests')}
                  >
                    <FontAwesomeIcon icon={faFileDownload} />
                    <span>Download CSV</span>
                  </Button>

                  {/* Column Dropdown */}

                </div>
              </div>
            </Col>
          </Row>

        </Row>
      </div>


      <TransactionsList
        page={page}
        setLimit={setLimit}
        limit={limit}
        setPage={setPage}
        totalPages={totalPages}
        transactions={transactions}
        isTenant={false}
        transactionType='deposit'
        loading={loading}
        openStatusModal={openStatusModal}
        openCryptoStatusModal={openCryptoStatusModal}
        closeStatusModal={closeStatusModal}
        agentId={agentId}
        handleStatusChange={handleStatusChange}
        handleAgentIdChange={handleAgentIdChange}
        updateTransactionStatus={updateTransactionStatus}
        updatingStatus={updatingStatus}
        newStatus={newStatus}
        showStatusModal={showStatusModal}
        selectedTransaction={selectedTransaction}
        driversList={driversList}
        visibleColumns={visibleColumns}
        tableMaxHeight={tableMaxHeight}
        showCryptoStatusModal={showCryptoStatusModal}
        setShowCryptoStatusModal={setShowCryptoStatusModal}
        updateCryptoTransactionStatus={updateCryptoTransactionStatus}
        loadingCrypto={loadingCrypto}
        setSelectedTransaction={setSelectedTransaction}
        selectedCrypto={selectedCrypto}
        totalCount={totalCount}
        countText="Total Deposits : "
        showTotalCount={true}

      />

    </div>
  );
}
